import { Pipe, PipeTransform } from '@angular/core';
import { environment } from './shared/config/app-config';
import { UserService, PatientService, User } from './shared';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'dateformateUs'
})
export class DateformateUsPipe implements PipeTransform {
  dateform: string;
  currentUser: User;
  private userService: UserService;
  private Datepipe: DatePipe
  constructor() {
    //super('')
  }
  transform(value: any, args?: any): any {
    if (value != undefined) {
      var dateStr = value.replace('00:00:00.0', '');
      try {
        var result
        this.userService.currentUser.subscribe(
          (userData) => {
            this.currentUser = userData;
            if (this.currentUser.item && this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
              this.dateform = environment.dateForm;
            } else if (this.currentUser.item && this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
              this.dateform = 'dd/MM/yyyy'
            }
            result = this.Datepipe.transform(dateStr, this.dateform);
          }

        );
      } catch (Exception) { }
      return result;
    }
  }
}


